
import {
  CheckCircleFilled,
} from "@ant-design/icons";
import { Template } from "./Step1";

type TemplateCardProps = {
  template: Template;
  selected: boolean;
  onSelect: (id: string | number | null) => void;
};

type DifficultyStyle = {
  bg: string;
  color: string;
};

const DIFFICULTY_COLOR: Record<string, DifficultyStyle> = {
  Beginner: { bg: "#CDE7CF", color: "#2E7D32" },
  Intermediate: { bg: "#FEF6E9", color: "#000" },
  Advanced: { bg: "#FBEAEA", color: "#D32F2F" },
};

export default function TemplateCard({ template, selected, onSelect }: TemplateCardProps) {
  const diff = DIFFICULTY_COLOR[template.difficulty] || DIFFICULTY_COLOR.Beginner;
  return (
    <div
      onClick={() => selected ? onSelect(null) : onSelect(template.value)}
      className="cs-template-card-wrapper"
      style={{
        border: selected ? "2px solid #006CA3" : "1px solid #EAEAEB",
        boxShadow: selected
          ? "0 0 0 3px rgba(0,108,163,0.15)"
          : "0px 2px 8px rgba(0,0,0,0.10)",
      }}
    >
      <div className="cs-relative">
        <img
          src="/placeholderImage.png"
          alt={template.label}
          className="cs-image-cover"
        />
        <span
          className="cs-image-word-cover"
          style={{
            background: diff.bg,
            color: diff.color
          }}
        >
          {template.difficulty}
        </span>
        {selected && (
          <div
            className="cs-selected-checkbox"
          >
            <CheckCircleFilled className="text-white fsx-16" />
          </div>
        )}
      </div>
      <div className="cs-template-card">
        <div className="cs-template-card-title">
          {template.label}
        </div>
        <div className="cs-template-card-category">
          {template.categories?.length ? template.categories?.join(", ") : ""}
        </div>
        <button
          className="cs-template-card-button"
          onClick={(e) => {
            e.stopPropagation();
            onSelect(template.value);
          }}
          style={{
            background: selected ? "#005a87" : "#006CA3",
          }}
        >
          {selected ? "✓ Selected" : "Select"}
        </button>
      </div>

    </div>
  );
}